module.exports = __webpack_public_path__ + "img/组 1.449bb57c.webp";